import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'teklif' | 'randevu';
}

function Modal({ isOpen, onClose, type }: ModalProps) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: '',
    date: '',
    time: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const submitUrl = 'https://readdy.ai/api/form/d308d5v348pq0eno6890';
      
      const response = await fetch(submitUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString()
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          service: '',
          message: '',
          date: '',
          time: ''
        });
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto animate-in fade-in zoom-in duration-200">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-2xl font-bold text-gray-900">
              {type === 'teklif' ? 'Teklif Al' : 'Randevu Al'}
            </h3>
            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            >
              <i className="ri-close-line text-xl text-gray-500"></i>
            </button>
          </div>

          {submitted ? (
            <div className="text-center py-8">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-3xl text-emerald-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">
                {type === 'teklif' ? 'Teklif Talebiniz Alındı' : 'Randevu Talebiniz Alındı'}
              </h4>
              <p className="text-gray-600 mb-6">
                En kısa sürede sizinle iletişime geçeceğiz.
              </p>
              <Button onClick={() => { setSubmitted(false); onClose(); }}>
                Tamam
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} data-readdy-form>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Ad Soyad *
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                      placeholder="Adınız ve soyadınız"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      E-posta *
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                      placeholder="e-posta@ornek.com"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Telefon
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                      placeholder="+90 5XX XXX XX XX"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Şirket Adı
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                      placeholder="Şirket adınız"
                    />
                  </div>
                </div>

                {type === 'randevu' && (
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Tercih Edilen Tarih
                      </label>
                      <input
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Tercih Edilen Saat
                      </label>
                      <select
                        name="time"
                        value={formData.time}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm pr-8"
                      >
                        <option value="">Saat seçiniz</option>
                        <option value="09:00">09:00</option>
                        <option value="10:00">10:00</option>
                        <option value="11:00">11:00</option>
                        <option value="14:00">14:00</option>
                        <option value="15:00">15:00</option>
                        <option value="16:00">16:00</option>
                      </select>
                    </div>
                  </div>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    İlgilendiğiniz Hizmet
                  </label>
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm pr-8"
                  >
                    <option value="">Hizmet seçiniz</option>
                    <option value="sustainability">Sürdürülebilirlik Danışmanlığı</option>
                    <option value="gri">GRI Sürdürülebilirlik Raporu</option>
                    <option value="tsrs">TSRS Sürdürülebilirlik Raporu</option>
                    <option value="csrd">CSRD Sürdürülebilirlik Raporu</option>
                    <option value="esg">ESG Danışmanlığı</option>
                    <option value="gap">GAP Analizi</option>
                    <option value="ecovadis">Ecovadis Danışmanlığı</option>
                    <option value="sbti">SBTi Danışmanlığı</option>
                    <option value="cdp">CDP Raporu</option>
                    <option value="carbon">Karbon Ayak İzi</option>
                    <option value="water">Su Ayak İzi</option>
                    <option value="lca">Yaşam Döngüsü Analizi</option>
                    <option value="epd">EPD Belgesi</option>
                    <option value="cbam">CBAM/SKDM Danışmanlığı</option>
                    <option value="other">Diğer</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mesajınız
                  </label>
                  <textarea
                    name="message"
                    rows={3}
                    value={formData.message}
                    onChange={handleChange}
                    maxLength={500}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="Projeniz hakkında detayları paylaşın..."
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1">
                    {formData.message.length}/500 karakter
                  </div>
                </div>
              </div>

              <div className="flex gap-3 mt-6">
                <Button
                  type="button"
                  variant="outline"
                  onClick={onClose}
                  className="flex-1"
                >
                  İptal
                </Button>
                <Button
                  type="submit"
                  disabled={isSubmitting || formData.message.length > 500}
                  className="flex-1 whitespace-nowrap"
                >
                  {isSubmitting ? (
                    <>
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-loader-4-line animate-spin"></i>
                      </div>
                      Gönderiliyor...
                    </>
                  ) : (
                    type === 'teklif' ? 'Teklif Al' : 'Randevu Al'
                  )}
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [modalState, setModalState] = useState<{ isOpen: boolean; type: 'teklif' | 'randevu' | null }>({
    isOpen: false,
    type: null
  });
  const location = useLocation();

  const navigation = [
    { name: 'Ana Sayfa', href: '/' },
    { name: 'Hizmetler', href: '/hizmetler' },
    { name: 'Hakkımızda', href: '/hakkimizda' },
    { name: 'İletişim', href: '/iletisim' }
  ];

  const openModal = (type: 'teklif' | 'randevu') => {
    setModalState({ isOpen: true, type });
  };

  const closeModal = () => {
    setModalState({ isOpen: false, type: null });
  };

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <img 
                  src="https://static.readdy.ai/image/433ae15a0e6a7b6ebcc53b7d6b9b5b41/aa80eed72f928092e0a973fadbe37ef6.png" 
                  alt="ECOVENTRA Logo" 
                  className="h-12 w-auto"
                />
              </Link>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-gray-700 hover:text-emerald-600 px-3 py-2 text-sm font-medium transition-colors ${
                    location.pathname === item.href ? 'text-emerald-600' : ''
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="flex space-x-2">
                <Button 
                  size="sm" 
                  variant="outline"
                  onClick={() => openModal('randevu')}
                  className="whitespace-nowrap"
                >
                  Randevu Al
                </Button>
                <Button 
                  size="sm"
                  onClick={() => openModal('teklif')}
                  className="whitespace-nowrap"
                >
                  Teklif Al
                </Button>
              </div>
            </div>

            <div className="md:hidden flex items-center">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
                </div>
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="md:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`block px-3 py-2 text-base font-medium text-gray-700 hover:text-emerald-600 ${
                      location.pathname === item.href ? 'text-emerald-600' : ''
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
                <div className="px-3 py-2 space-y-2">
                  <Button 
                    size="sm" 
                    variant="outline"
                    onClick={() => { openModal('randevu'); setIsMenuOpen(false); }}
                    className="w-full whitespace-nowrap"
                  >
                    Randevu Al
                  </Button>
                  <Button 
                    size="sm"
                    onClick={() => { openModal('teklif'); setIsMenuOpen(false); }}
                    className="w-full whitespace-nowrap"
                  >
                    Teklif Al
                  </Button>
                </div>
              </div>
            </div>
          )}
        </nav>
      </header>

      <Modal 
        isOpen={modalState.isOpen} 
        onClose={closeModal} 
        type={modalState.type!} 
      />
    </>
  );
}
